// Account language — shared vocabulary. Deliberately free of any Supabase or
// server-function import so the client bundle, the server functions and the
// API routes can all agree on the same three values without dragging each
// other's machinery along.

export type AccountLocale = "ru" | "az" | "en";

export const ACCOUNT_LOCALES = ["ru", "az", "en"] as const;

/** Narrow anything (URL param, DB text, navigator.language) to a known locale. */
export function isAccountLocale(v: unknown): v is AccountLocale {
  return typeof v === "string" && (ACCOUNT_LOCALES as readonly string[]).includes(v);
}

/** Same, but always yields a value. Unknown input → Russian, the historical
 *  default of profiles.locale, so this never invents a language change. */
export function normAccountLocale(v: unknown): AccountLocale {
  return isAccountLocale(v) ? v : "ru";
}
